export default __webpack_public_path__ + "static/media/DSC09971.73c565d6.jpg";